import React from 'react'
import {findDOMNode} from "react-dom"

import Popover from '../gd-popover/popover-v2'
import PopoverPosition from '../gd-popover/popover-position'
import PriorityIcon from "../priority/priority-icon/priority-icon"

type Props = {
    onUserSelect?       : callback
    options?            : any[]
    placeholder?        : string
    value?              : number
    disabled?           : boolean
    noEmergency?        : boolean
    noBlocker?          : boolean

    attachment?         : string
    targetAttachment?   : string
    targetOffset?       : string

    onTogglePopover?    : callback

    type?               : string
    companyId?          : string

    inline?             : boolean

    className?          : string

    deleteButton?       : boolean
    onReset?            : callback
}

type State = {
    showPopover : boolean
    value       : number
}

export default class PrioritySelector extends React.Component<Props, State> {

    static defaultProps: Partial<Props> = {
        placeholder: 'Select Priority',
        disabled: false,
        attachment: "top right",
        targetAttachment: "bottom left",
        targetOffset: "-126 0",
        inline: false,
        type: "task",
        deleteButton: false,
    }

    constructor(props:Props) {
        super(props)

        this.state = {
            showPopover: false,
            value: this.props.value
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps:Props) {
        if (this.state.value !== nextProps.value){
            this.setState({
                value: nextProps.value
            })
        }
    }

    onClickActions = (e:any) => {
        if (!this.props.disabled) {
            e.stopPropagation()
            const showPopover = !this.state.showPopover
            this.setState({
                showPopover: showPopover
            })
            if (this.props.onTogglePopover) this.props.onTogglePopover(showPopover)
        }
    }

    hidePopover = (value?:any) => {
        this.setState({
            showPopover: false,
            value: value ? value : this.state.value
        }, ()=>{
            if (this.props.onTogglePopover) this.props.onTogglePopover(false)
            if (value && this.props.onUserSelect) this.props.onUserSelect(value)
        })
    }

    onPriorityClick = (value:any) => {
        this.hidePopover(value)
    }

    getOptions = () => {
        let options

        if (this.props.options) options = this.props.options

        if (this.props.companyId) {
            options =  gd.session.companies.get(this.props.companyId).priorities.exportToOptions()
        }

        return options
    }

    renderPopover = () => {
        const options = this.getOptions()

        const emergencyLabel:any = _.result(_.find(options, (o:any) => {return o.value === gd.const.priority.levels.emergency}), 'label')
        const bottleneckLabel:any = _.result(_.find(options, (o:any) => {return o.value === gd.const.priority.levels.blocker}), 'label')

        // no blocker for proj
        let blockerEmergency = null
        if ((!this.props.noEmergency || !this.props.noBlocker) && this.props.type!=='project'){
            blockerEmergency = (
                <div className="priority-group">
                    {!this.props.noEmergency && <div className="priority" onClick={this.onPriorityClick.bind(this, gd.const.priority.levels.emergency)}>
                        <PriorityIcon className="priority-icon" priority={gd.const.priority.levels.emergency}/>
                        <div className="priority-name">{emergencyLabel}</div>
                    </div>}
                    {!this.props.noBlocker && <div className="priority" onClick={this.onPriorityClick.bind(this, gd.const.priority.levels.blocker)}>
                        <PriorityIcon className="priority-icon" priority={gd.const.priority.levels.blocker}/>
                        <div className="priority-name">{bottleneckLabel}</div>
                    </div>}
                </div>
            )
        }

        if (this.state.showPopover) {
            const popoverPosition = new PopoverPosition({
                attachment      : this.props.attachment,
                targetAttachment: this.props.targetAttachment,
                targetOffset    : this.props.targetOffset,
            })

            return (
                <Popover popoverClass="priority-popover"
                         className="priority-content"
                         position={popoverPosition}
                         getTargetFunc={()=>findDOMNode(this)}
                         onClickOutside={()=>{this.hidePopover()}}>

                    {blockerEmergency}

                    <div className="priority-group">
                        {options.map((option:any, key:number)=>{
                            if (option.value > 10 ) return null

                            return (
                                <div key={key}
                                     className="priority"
                                     onClick={this.onPriorityClick.bind(this, option.value)}>
                                    <PriorityIcon className="priority-icon" priority={option.value}/>
                                    <div className="priority-name">{option.label}</div>
                                </div>
                            )
                        })}
                    </div>
                </Popover>
            )
        }
    }

    onRemoveClick = () => {
        this.onPriorityClick(5)
        if (this.props.onReset) this.props.onReset()
    }

    render() {
        const options = this.getOptions()

        let valueLabel:any = this.props.placeholder
        if (this.state.value) {
            valueLabel = _.result(_.find(options, (o:any)=>o.value === this.state.value), 'label')
            if (!valueLabel) valueLabel = this.state.value
        }

        const classes = Classes('priority-container', this.props.className, {
            disabled: this.props.disabled,
            inline: this.props.inline
        })

        const valueClasses = Classes('selected-value', 'value_' + this.state.value)

        const selectorClasses = Classes('priority-selector', {
            inline: this.props.inline,
            'not-set': !this.state.value
        })

        return (
            <div className={classes}>
                <div className={selectorClasses} onClick={this.onClickActions}>
                    <PriorityIcon className="priority-icon" priority={this.state.value}/>
                    <div className={valueClasses}>{valueLabel}</div>

                    {this.props.deleteButton &&
                    <div className="delete-icon i5-delete-circle-solid" onClick={this.onRemoveClick}> </div>}
                </div>

                {this.renderPopover()}
            </div>
        )
    }
}
